import React from 'react'

const SessionContext = React.createContext({
  msalSession: {},
  setMsalSession: () => {}
})

export default SessionContext